import { render, staticRenderFns } from "./middle.vue?vue&type=template&id=cfe677ec&scoped=true&"
import script from "./middle.vue?vue&type=script&lang=js&"
export * from "./middle.vue?vue&type=script&lang=js&"
import style0 from "./middle.vue?vue&type=style&index=0&id=cfe677ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe677ec",
  null
  
)

export default component.exports